import classNames from 'classnames';
import { FC } from 'react';
import TabPicker from 'src/view/components/Controls/Pickers/TabPicker/TabPicker';
import Text, { TEXT } from 'src/view/components/Text/Text';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';
import './style.scss';

interface IProps {
  title: string;
  activeTab: IPickerOption['value'];
  options: IPickerOption[];
  onChangeTab: (value: IPickerOption['value']) => void;
  className?: string;
  titleClassName?: string;
}

const ConfigPicker: FC<IProps> = (props: IProps): JSX.Element => {
  return (
    <div className={classNames('config-picker', props.className)}>
      <Text type={TEXT.ORDER_FIELD} text={props.title} className={props.titleClassName} />
      <TabPicker value={props.activeTab} options={props.options} onChange={props.onChangeTab} />
    </div>
  );
};

export default ConfigPicker;
